import { requestHelpers } from '../../helpers';
import { updateTodoList } from '../todo_list/todo_list';

const actions = {
    GET_ALL_CONVERSATIONS: 'GET_ALL_CONVERSATIONS',
    SET_ALL_CONVERSATIONS: 'SET_ALL_CONVERSATIONS',
    GET_CONVERSATION: 'GET_CONVERSATION',
    SET_CONVERSATION: 'SET_CONVERSATION',
    GET_CONVERSATION_ERROR: 'GET_CONVERSATION_ERROR',
    CREATE_NEW_CONVERSATION: 'CREATE_NEW_CONVERSATION',
    POST_NEW_CONVERSATION: 'POST_NEW_CONVERSATION',
    GET_A_PERSONS_CONVERSATIONS: 'GET_A_PERSONS_CONVERSATIONS',
    SET_A_PERSONS_CONVERSATIONS: 'SET_A_PERSONS_CONVERSATIONS',
    SET_DELETE_CONVERSATION: 'SET_DELETE_CONVERSATION',
    POST_DELETE_CONVERSATION: 'POST_DELETE_CONVERSATION',
    ADD_PERSON_TO_CONVERSATION: 'ADD_PERSON_TO_CONVERSATION',
    POST_PERSON_TO_CONVERSATION: 'POST_PERSON_TO_CONVERSATION',
    SET_DELETE_PERSON_FROM_CONVERSATION: 'SET_DELETE_PERSON_FROM_CONVERSATION',
    POST_DELETE_PERSON_FROM_CONVERSATION: 'POST_DELETE_PERSON_FROM_CONVERSATION',
    ADD_SEND_MESSAGE: 'ADD_SEND_MESSAGE',
    POST_SEND_MESSAGE: 'POST_SEND_MESSAGE',
};

function getAllConversations( page ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_ALL_CONVERSATIONS,
        } );

        const newOptions = {};

        if( !page ) {
            newOptions.page = 1;
        }else {
            newOptions.page = page;
        }

        requestHelpers
            .authenticatedGetRequest( '/conversations', newOptions )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_ALL_CONVERSATIONS,
                    conversations: response.data,
                    pagination: response.meta,
                } );
            } );
    }
}

function getConversation( conversationId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_CONVERSATION,
        } );

        requestHelpers
            .authenticatedGetRequest( `/conversations/${ conversationId }` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_CONVERSATION,
                    conversation: response.data,
                } );
            }, ( error ) => {
                dispatch( {
                    type: actions.GET_CONVERSATION_ERROR,
                    status: error.status,
                } );
            } )
    }
}

function createConversation( message, recipients, personId ) {
    const _message = {};
    _message.message = message;
    _message.recipients = recipients;
    return ( dispatch ) => {
        requestHelpers
            .authenticatedPostRequest( '/conversations', _message )
            .then( ( response ) => {
                return dispatch( {
                    type: actions.CREATE_NEW_CONVERSATION,
                    message: message,
                    recipients,
                } );
            } ).catch((error) => console.log( 'LOG: error', error  ))
      dispatch(updateTodoList(personId, 4));
    };
}

function sendMessage( conversationId, contents, personId ) {

    return ( dispatch ) => {
        dispatch( {
            type: actions.ADD_SEND_MESSAGE,
        } );

        requestHelpers
            .authenticatedPostRequest( `/conversations/${ conversationId }/messages`, {contents: contents} )
            .then( () => {
                dispatch( {
                    type: actions.POST_SEND_MESSAGE,
                    contents,
                } );
                dispatch(getConversation( conversationId ))
            } ).catch((error) => console.log( 'LOG: error', error  ))
      dispatch(updateTodoList(personId, 4));
    };
}


module.exports = {
    actions,
    getAllConversations,
    getConversation,
    createConversation,
    sendMessage
};



// WEBPACK FOOTER //
// src/client/actions/networking/networking.js